<template>
  <div class="middle">
    <div class="middle-left">
      <div class="name">注册人数</div>
      <div class="top_b">
        <div class="top_m">
          <div class="allN">注册总人数:</div>
          <div class="number">
            <div class="box-item">
              <li
                :class="{'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
                v-for="(item,index) in orderNum"
                :key="index"
              >
                <span v-if="!isNaN(item)">
                  <i ref="numberItem">
                    0123456789
                  </i>
                </span>
                <span class="comma" v-else>{{item}}</span>
              </li>
            </div>
          </div>
        </div>
      </div>
      <div class="Rdiv">
        <div class="top_b">
          <div class="top_m">
            <div class="div-top">现在线人数:</div>
            <div class="number">
              <div class="box-item">
                <li
                  :class="{'number-item': !isNaN(item), 'mark-item': isNaN(item) }"
                  v-for="(item,index) in orderNum2"
                  :key="index"
                >
                  <span v-if="!isNaN(item)">
                    <i ref="numItem">0123456789</i>
                  </span>
                  <span class="comma" v-else>{{item}}</span>
                </li>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="bot">
        <div class="div-bot">职称统计</div>
        <div id="botChart" :style="{ width: '100%', height: '260px', margin: '-20px 0 0 0' }"></div>
      </div>
    </div>
    <div class="middle-child" ref="middle">
      <div class="name">区域</div>
      <!-- <div id="map"
           :style="{ width: '100%', height: '280px'}"
      class="map"></div>-->
      <AreaMap :w="w" :h="h" />
    </div>
    <div class="middle-right">
      <div class="name">专业排名前七</div>
      <div id="myChart" :style="{ width: '100%', height: '400px', margin: '20 0 0 0' }"></div>
    </div>
  </div>
</template>
<script>
let echarts = require("echarts/lib/echarts");
// import echartsgl from 'echarts-gl';
import AreaMap from "./AreaMap";
import "../assets/gansu.js";

export default {
  name: "MiddleSet",
  components: {
    AreaMap
  },
  data() {
    return {
      w: "",
      h: "",
      a: 100,
      orderNum: [],
      orderNum2: [],
      zcData: [],
      zyData:[],
      proCourseTotalCount:null,
    };
  },
  methods: {
    getWitHgth() {
      this.w = this.$refs.middle.clientWidth + "px";
      this.h = this.$refs.middle.clientHeight + "px";
    },
    //数据
    viewData() {     
      const url = '/qhjxjy_cms/DataStatistical!getData.action';
      const this_ = this;
      this_.axios.get(url).then(res=>{
        if(res.status === 200){
          // console.log(res)
          this_.zcData= []
          this_.zyData = []
          this_.orderNum2 = res.data.nowOnlineCount // 在线人数
          this_.orderNum = res.data.totalRegistCount // 注册人数
          setInterval(() => {
                this_.toOrderNum(this_.orderNum)
                this_.toOrderNum1(this_.orderNum2)
            // 这里输入数字即可调用
            // console.log(this_.orderNum)
          //   console.log(res.data.totalRegistCount)
          }, 500);
          this_.proCourseTotalCount = res.data.proCourseTotalCount

          // 整合职称data
          this_.zcData = [
            {value:res.data.professionalTitleZG,name:'正高'},
            {value:res.data.professionalTitleFG,name:'副高'},
            {value:res.data.professionalTitleZJ,name:'中级'},
            {value:res.data.professionalTitleCJ,name:'初级'},
            {value:res.data.professionalTitleYJ,name:'元级'},
          ]
          
          var backZY = JSON.parse(res.data.proCourse)
          
          if(backZY) {
            backZY.forEach(item => {
              var zyObj = {};
              zyObj.name = item[0]
              zyObj.value = item[1]
              this_.zyData.push(zyObj)
            })
          }
          this.titleChart();
          this.pieChart();
        }
      })
      // var backData = JSON.parse(sessionStorage.getItem('backData'))
      
    },

    // 职称
    titleChart() {
      let myChart = echarts.init(document.getElementById("botChart"));
      let angle = 0; //角度，用来做简单的动画效果的
      var timerId;
      let option = {
        // backgroundColor: "#000E1A",
        title: {
          // text: "{a|" + value + "}{c|%}",
          x: "center",
          y: "center",
          textStyle: {
            rich: {
              a: {
                fontSize: 48,
                color: "#29EEF3"
              },

              c: {
                fontSize: 20,
                color: "#ffffff",
                padding: [5,0]
              }
            }
          }
        },
        legend: {
          orient: 'vertical',
          y: 'center',    //延Y轴居中
          x: 'right', //居右显示
          left: "86%",
          top: "18%",
          radius:'50%',
          itemHeight: 20,
          itemWidth: 8,
          icon: "roundRect", 
          padding:-0.5,
          textStyle: {
            color: "#ccc",
            width: 16,
            fontSize:12
          }
        },
        tooltip: {
        // trigger: 'item'
        },
        series: [
          // 紫色
          {
            // name: "紫色",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.55,
                  startAngle: ((0 + angle) * Math.PI) / 180,
                  endAngle: ((90 + angle) * Math.PI) / 180
                },
                style: {
                  stroke: "#8383FA",
                  fill: "transparent",
                  lineWidth: 1.5
                },
                silent: true
              };
            },
            data: [0]
          },
          {
            // name: "ring5", //紫点
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.55;
              let point = getCirlPoint(x0, y0, r, 90 + angle);
              return {
                type: "circle",
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 4
                },
                style: {
                  stroke: "#8450F9", 
                  fill: "#8450F9"
                },
                silent: true
              };
            },
            data: [0]
          },
          // 蓝色
          {
            // name: "蓝色",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.55,
                  startAngle: ((180 + angle) * Math.PI) / 180,
                  endAngle: ((270 + angle) * Math.PI) / 180
                },
                style: {
                  stroke: "#4386FA",
                  fill: "transparent",
                  lineWidth: 1.5
                },
                silent: true
              };
            },
            data: [0]
          },
          {
            // name: "蓝点", // 
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.55;
              let point = getCirlPoint(x0, y0, r, 180 + angle);
              return {
                type: "circle",
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 4
                },
                style: {
                  stroke: "#4386FA", //蓝
                  fill: "#4386FA"
                },
                silent: true
              };
            },
            data: [0]
          },
          // 绿色
          {
            // name: "绿色",
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6,
                  startAngle: ((270 + -angle) * Math.PI) / 180,
                  endAngle: ((40 + -angle) * Math.PI) / 180
                },
                style: {
                  stroke: "#0CD3DB",
                  fill: "transparent",
                  lineWidth: 1.5
                },
                silent: true
              };
            },
            data: [0]
          },
          {
            // name: "ring5", //绿点
            center:['45%', '45%'],
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2) * 0.6;
              let point = getCirlPoint(x0, y0, r, 270 + -angle);
              return {
                type: "circle",
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 4
                },
                style: {
                  stroke: "#0CD3DB", //绿
                  fill: "#0CD3DB"
                },
                silent: true
              };
            },
            data: [0]
          },
          // 粉色
          {
            center:['45%', '45%'],
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              return {
                type: "arc",
                shape: {
                  cx: api.getWidth() / 2,
                  cy: api.getHeight() / 2,
                  r: (Math.min(api.getWidth(), api.getHeight()) / 2) *0.6,
                  startAngle: ((90 + -angle) * Math.PI) / 180,
                  endAngle: ((220 + -angle) * Math.PI) / 180
                },
                style: {
                  stroke: "#FF8E89",
                  fill: "transparent",
                  lineWidth: 1.5
                },
                silent: true
              };
            },
            data: [0]
          },
          {
            center:['45%', '45%'],
            type: "custom",
            coordinateSystem: "none",
            renderItem: function(params, api) {
              let x0 = api.getWidth() / 2;
              let y0 = api.getHeight() / 2;
              let r = (Math.min(api.getWidth(), api.getHeight()) / 2) *0.6;
              let point = getCirlPoint(x0, y0, r, 90 + -angle);
              return {
                type: "circle",
                shape: {
                  cx: point.x,
                  cy: point.y,
                  r: 4
                },
                style: {
                  stroke: "#FF8E89", //粉
                  fill: "#FF8E89"
                },
                silent: true
              };
            },
            data: [0]
          },
          // 圆环
          {
            type: "pie",
            radius: ["43%", "30%"],
            startAngle: 90,
            label: {
              show: false,
              position: "center"
            },
            data:this.zcData,
            color: [
                            "#3fb1fb",
                            "#7c2ce0",
                            "#df47d7",
                            "skyblue",
                            "pink",
                          ],
            
          },
        ]
      };

       //获取圆上面某点的坐标(x0,y0表示坐标，r半径，angle角度)
 function getCirlPoint(x0, y0, r, angle) {
     let x1 = x0 + r * Math.cos(angle * Math.PI / 180)
     let y1 = y0 + r * Math.sin(angle * Math.PI / 180)
     return {
         x: x1,
         y: y1
     }
 }

 function draw() {
     angle = angle + 3
     myChart.setOption(option, true)
     //window.requestAnimationFrame(draw);
 }
 if (timerId) {
     clearInterval(timerId);
 }
 timerId = setInterval(function() {
     //用setInterval做动画感觉有问题
     draw()
 }, 100);
    },

    // 专业(饼图)
    pieChart() {
      let myChart = echarts.init(document.getElementById("myChart"));
      // 绘制图表
      myChart.setOption({
        tooltip: {},
        legend: {
          top: "bottom",
          itemHeight: 15,
          itemWidth: 30,
          padding:-0.5,
          textStyle: {
            color: "#ccc",
            width: 26,
            fontSize:14
          }
        },
        graphic: {
          //2、中心的文字设置
          type: "text",
          left: "46.2%",
          top: "36.5%",
          z: 2,
          style: {
            fill: "#fff",
            font: "18px 微软雅黑",
            textAlign: "center",
            text: this.proCourseTotalCount,
          },
        },
        series: [
          {
            type: "pie",
            radius: [40, 80],
            center: ["53%", "38%"],
            roseType: "area",
            label: {
              normal: {
                formatter: params => {
                  return (
                    "{name|" +
                    params.name +
                    "}\n{hr|}\n{percent|" +
                    params.value +
                    "}"
                  );
                },
                distanceToLabelLine: 0,
                padding: [-2, 0, 0, 0],
                rich: {
                  name: {
                    color: "rgba(255, 255, 255, 0.9)",
                    fontSize: 12,
                    padding: [6, 10],
                    align: "left"
                  },
                  percent: {
                    color: "rgba(255, 255, 255, 0.9)",
                    align: "center",
                    fontSize: 14,
                    padding: [5, 10]
                  },
                  hr: {
                    borderColor: "#2aaefa",
                    width: "100%",
                    borderWidth: 0.5,
                    height: 0
                  }
                }
              },
            },
            labelLine: {
              show: true,
              normal: {
                length: 10,
                length2: 0,
                lineStyle: {
                  width: 1,
                  color: "#2aaefa"
                }
              }
            },
            color: [
              "#4caff9",
              "#55cd65",
              "#ff8b00",
              "#0271f3",
              "#f0ef00",
              "#f65456",
              "#517cff"
            ],
            data: this.zyData
          }
        ]
      });
    },

    // 设置文字滚动
    setNumberTransform () {
      const numberItems = this.$refs.numberItem // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum.filter(item => !isNaN(item))
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
    // 处理总订单数字
    toOrderNum (num) {
      num = num.toString()
      // 把订单数变成字符串
      if (num.length < 8) {
        num = '0' + num // 如未满八位数，添加"0"补位
        this.toOrderNum(num) // 递归添加"0"补位
      } else if (num.length === 8) {
        // 订单数中加入逗号
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.orderNum = num.split('') // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过7位显示异常
        // this.$message.warning('总量数字过大')
      }
      this.setNumberTransform()
    },
    // 设置文字滚动
    setNumberTransform1 () {
      const numberItems = this.$refs.numItem // 拿到数字的ref，计算元素数量
      const numberArr = this.orderNum2.filter(item => !isNaN(item))
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
    // 处理总订单数字
    toOrderNum1 (num) {
      num = num.toString()
      // 把订单数变成字符串
      if (num.length < 8) {
        num = '0' + num // 如未满八位数，添加"0"补位
        this.toOrderNum1(num) // 递归添加"0"补位
      } else if (num.length === 8) {
        // 订单数中加入逗号
        // num = num.slice(0, 2) + ',' + num.slice(2, 5) + ',' + num.slice(5, 8)
        this.orderNum2 = num.split('') // 将其便变成数据，渲染至滚动数组
      } else {
        // 订单总量数字超过7位显示异常
        // this.$message.warning('总量数字过大')
      }
      this.setNumberTransform1()
    },
  },
  created() {
    this.viewData();
  },
  mounted() {
    window.addEventListener("resize", () => {
      this.getWitHgth();
      echarts.init(document.getElementById("myChart")).resize();
    });
    window.addEventListener("resize", () => {
      echarts.init(document.getElementById("botChart")).resize();
    });

    // setInterval(() => {
    //   setTimeout(() => {
    //     // console.log('重新请求了')
    //     this.viewData();
    //   }, 0);
    // }, 3000);

    setInterval(() => {
      setTimeout(() => {
        // console.log('重新请求了')
       this.titleChart();
      }, 0);
    }, 1000*60*60*24);
    
    // setInterval(() => {
    //   setTimeout(() => {
    //     // console.log('重新请求了')
    //    this.titleChart();
    //   }, 0);
    // }, 1000*60*60*24);
  }
};
</script>
<style scoped>
.box-item {
  /* position: relative;
  height: 100px;
  font-size: 54px;
  line-height: 41px; */
  text-align: center;
  list-style: none;
  color: #2d7cff;
  writing-mode: vertical-lr;
  text-orientation: upright;
  /*文字禁止编辑*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  -khtml-user-select: none; /*早期浏览器*/
  user-select: none;
  /* overflow: hidden; */
  /*margin-left: -10px;*/
}
/* 默认逗号设置 */
.mark-item {
  width: 10px;
  height: 100px;
  margin-right: 5px;
  line-height: 10px;
  font-size: 48px;
  position: relative;
}
.mark-item > span {
  position: absolute;
  width: 100%;
  bottom: 0;
  writing-mode: vertical-rl;
  text-orientation: upright;
}
/*滚动数字设置*/
.number-item {
  width: 28px;
  height: 50px;
  /* 背景图片 */
  background: url("../assets/numbg.png") no-repeat center center;
  background-size: 100% 100%;
  list-style: none;
  margin-right: 5px;
  border-radius: 4px;
  border: solid 1px #21abec;
}
.number-item > span {
  position: relative;
  display: inline-block;
  margin-right: 10px;
  width: 120%;
  height: 100%;
  writing-mode: vertical-rl;
  text-orientation: upright;
  overflow: hidden;
  /* background: #0f0285; */
  font-size: 30px;
  color: #fff;
}
.number-item > span > i {
  font-style: normal;
  position: absolute;
  top: 11px;
  left: 43%;
  transform: translate(-50%, 0);
  transition: transform 1s ease-in-out;
  letter-spacing: 10px;
}

.number-item:last-child {
  margin-right: 0;
}

.middle {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.middle >>> .el-progress__text {
  color: rgba(6, 0, 59, 1);
}
.top_m, .Rdiv {
  display: flex;
  align-items: center;
  /* justify-content: center; */
  margin: 20px 0
}
.name {
  color: #96ccff;
  font-size: 20px;
  letter-spacing: 2px;
  background-image: -webkit-linear-gradient(left, #13025e, #13025e40);
  margin: -10px;
  padding: 10px;
  z-index: 99;
}
.middle-left {
  padding: 10px;
  box-sizing: border-box;
  width: 26%;
  height: 490px;
}
.allN,.div-top,.div-bot {
  color: #fff;
  margin-right: 20px;
  font-size: 18px;
}
.top_b,.div-bot {
  margin-left: 50px;
}

.number {
  display: flex;
  align-items: center;
  /* margin-bottom: 40px; */
  justify-content: space-between;
}

.div-bottom {
  font-size: 21px;
  color: #27fffc;
}
.proportion {
  display: flex;
  justify-content: space-around;
}
.complete {
  margin-bottom: 10px;
  color: #6f6f6f;
  font-size: 14px;
}
.left,
.midd,
.right {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  margin-right: 20px;
}
.middle-child {
  width: 46%;
  padding: 10px;
  box-sizing: border-box;
  height: 550px;
}
.middle-right {
  padding: 10px;
  box-sizing: border-box;
  width: 26%;
  height: 490px;
}
.box {
  margin-top: 10px;
}
.middle-right,
.middle-child,
.middle-left {
  background: rgba(0, 0, 0, 0.2);
  box-shadow: 0px 0px 0px 1px #0c0165;
  border-left: 1px transparent solid;
  border-right: 1px transparent solid;
  border-top: 2px transparent solid;
  border-image: linear-gradient(to top, #130963, #130963, #130963, #614ba4) 1 10;
}
.proChild {
  position: absolute;
  top: 50%;
  /* display: block; */
  /* background: #080147; */
  z-index: 1;
  width: 60px;
  font-size: 14px;
  text-align: center;
  border-radius: 50%;
}
.map {
  margin-top: 10px;
}
#myChart {
  margin-top: 10px;
}
</style>
<style>
.el-progress-circle__track {
  stroke: #332f62;
}
</style>